// Angulr
import { NgModule } from '@angular/core';
import { type Routes, RouterModule } from '@angular/router';
// Components
import { SlideMainComponent } from './main/slide-main.component';
import { SlideComponent } from './slide.component';

const routes: Routes = [
  {
    path: '',
    component: SlideComponent,
    children: [
      { path: '', component: SlideMainComponent }
    ]
  },
];

@NgModule({
  imports: [
    // Angular
    RouterModule.forChild(routes),
  ],
  exports: [
    // Angular
    RouterModule,
  ]
})
export class SlideRoutingModule {
}
